<template>
  <div class="form-wrapper">
    <v-form v-model="isVerified">
      <v-text-field
        v-model="name"
        autofocus
        :rules="[v => !!v || 'Please set a name!']"
        persistent-hint
        hint="Slide Name"
        :loading="isLoading"
        solo
        flat
        label="Mainly the headline of the slide"
      />
      <v-text-field
        v-model="keyMessage"
        :rules="[
          v => !!v || 'Please set a key message!',
          v => (v && v.length >= 5) || 'Key Message must container 5 or more character.'
        ]"
        persistent-hint
        hint="Slide Key Message"
        solo
        :loading="isLoading"
        flat
        label="Your CLM Key Message"
      />
      <!-- TODO: HERE CHECK WHETER COUNTRY IS MASTER OR NOT AND CAPABILITIES -->
      <v-checkbox
        v-model="mandatory"
        :disabled="!$store.getters['localization/isMaster']"
        hint="Mandatory slides must be localized by countries"
        label="Mandatory Slide"
        persistent-hint
      />
    </v-form>
    <div class="actions layout mt-4  align-center">
      <div>
        <input v-model="extend" type="checkbox" :value="extend" />
        <span class="muted ml-2">Add more</span>
      </div>
      <v-spacer />
      <core-button
        secondary
        class="mr-3"
        not-rounded
        flat
        label="Cancel"
        @click.stop="$router.push({ query: { dialog: null, form: null } })"
      />
      <core-button
        :is-loading="isLoading"
        :disabled="!isVerified"
        not-rounded
        flat
        label="Create Slide"
        @click.stop="createSlide"
      />
    </div>
  </div>
</template>

<script>
import CoreButtonVue from '../../../buttons/CoreButton.vue';
import { CREATE_SLIDE } from '../../../../../config/constants';
import { changeQuery } from '../../../../../router';

export default {
  name: 'CreateSlideDialog',
  components: {
    coreButton: CoreButtonVue
  },
  data() {
    return {
      name: null,
      keyMessage: null,
      isVerified: false,
      isLoading: false,
      extend: false,
      mandatory: false
    };
  },
  methods: {
    createSlide() {
      if (this.isVerified) {
        this.isLoading = true;
        this.$store
          .dispatch(CREATE_SLIDE, {
            name: this.name,
            keyMessage: this.keyMessage,
            mandatory: this.mandatory
          })
          .then(async slide => {
            if (slide) {
              await this.$store.dispatch('alerts/success', 'Created slide with ID: ' + slide.externalId);
              if (!this.extend) changeQuery({ dialog: false, asset: slide._id });
              this.name = null;
              this.keyMessage = null;
              this.mandatory = false;
              this.$store.dispatch('getAll');
            }
          })
          .catch(err => {})
          .finally(() => (this.isLoading = false));
      }
    }
  }
};
</script>

<style scoped>
.form-wrapper {
  height: 100%;
  display: flex;
  flex-direction: column;
}
</style>
